var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-graph-table style"},[(_vm.ready)?_c('div',{staticClass:"device-graph style",staticStyle:{"color":"#fff"}},[_c('highcharts',{attrs:{"options":_vm.chartOptions,"constructor-type":'stockChart'}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }